import React from "react";
import PropTypes from "prop-types";
import { Breadcrumbs, PageHeader } from "@opendate-app/setlist";
import "./classesShared.css";

export function DetailColumns({ rail, children }) {
  return (
    <div className="classes-detail-columns">
      <div className="classes-detail-columns__main">{children}</div>
      {rail && <aside className="classes-detail-columns__rail">{rail}</aside>}
    </div>
  );
}

DetailColumns.propTypes = { rail: PropTypes.node, children: PropTypes.node };

export default function DetailPageLayout({ breadcrumbs, avatar, title, badges, supportingText, actions, tabs, sectionTitle, children }) {
  return (
    <div className="od-themed p-4">
      <PageHeader
        divider={false}
        breadcrumbs={breadcrumbs && breadcrumbs.length > 0 ? <div className="classes-wrapping-crumbs"><Breadcrumbs items={breadcrumbs} /></div> : undefined}
        avatar={avatar}
        title={(
          <span className="d-inline-flex align-items-center flex-wrap classes-gap-12">
            <span role="heading" aria-level={1}>{title}</span>
            {badges}
          </span>
        )}
        supportingText={supportingText}
        actions={actions}
      />
      {tabs && <div className="mt-3 classes-detail-tabs">{tabs}</div>}
      <div className="mt-4">
        {sectionTitle && <h2 className="sr-only">{sectionTitle}</h2>}
        {children}
      </div>
    </div>
  );
}

DetailPageLayout.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.node, href: PropTypes.string })),
  avatar: PropTypes.node,
  title: PropTypes.node.isRequired,
  badges: PropTypes.node,
  supportingText: PropTypes.node,
  actions: PropTypes.node,
  tabs: PropTypes.node,
  sectionTitle: PropTypes.string,
  children: PropTypes.node,
};
